<template>
	<div>
		<headers></headers>
		<div class="py-4 px-4 terms-flex-box">
			<div class="">
				<div class="ftr-1-5 ftw600 px-3"> {{$t('footers.termsofService')}}</div>
				<ul class="nav flex-column terms-flex mt-3 nav-item-width ">
					<li class="nav-item  mb-2 ftr-1-25  px-sm-3 py-sm-2 clickAct" :class="tabIndex==0?'nav-item-select':''"  @click="selectTab(0)"> {{$t('footers.termsofUse')}}</li>
					<li class="nav-item  mb-2 ftr-1-25  px-sm-3 py-sm-2 clickAct" :class="tabIndex==4?'nav-item-select':''"  @click="selectTab(4)"> {{$t('footers.teacherServiceAgreement')}}</li>
					<li class="nav-item mb-2 ftr-1-25 px-sm-3 py-sm-2 clickAct" :class="tabIndex==1?'nav-item-select':''" @click="selectTab(1)">{{$t('footers.privacyPolicy')}}</li>
					<li class="nav-item mb-2 ftr-1-25 px-sm-3 py-sm-2 clickAct" :class="tabIndex==2?'nav-item-select':''" @click="selectTab(2)">{{$t('footers.cookie')}}</li>
				</ul>
			</div>
			<div class="ms-2" v-if="tabIndex==0">
				{{list[3].description}}
			</div>
			<div class="ms-2" v-if="tabIndex==1">
				 {{list[1].description}}
			</div>
			<div class="ms-2" v-if="tabIndex==2">
				{{list[0].description}}
			</div>
			<div class="ms-2" v-if="tabIndex==4">
				
				{{list[2].description}}
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				tabIndex:0,
				list:[]
			}
		},
		created() {
			this.getCategory()
		},
		methods:{
			selectTab(index){
				this.tabIndex = index
			},
			getCategory(){
				this.$http.api('index/category',{
					pid:29
				}).then(res=>{
					console.log("res",res);
					this.list = res.list
				})
			},
		}
	}
</script>

<style>
	.terms-flex-box{
		display: flex;
	}
	.nav-item-select{
		background-color: #EBEAEA;
		color: #52C4C9;
	}
	.nav-item-width{
		width: 200px;
	}
	@media (max-width: 575.98px) {
		.terms-flex{
			display: flex;
			flex-direction: row !important;
			justify-content: space-around;
		}
		.terms-flex li{
			font-size: 16px !important;
		}
		.terms-flex-box{
			display: flex;
			flex-direction: column;
		}
		.nav-item-width{
			width: 100%;
		}
	}
</style>